import { SearchForm } from "@/component-create/SearchForm";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FORM_ITEM } from "@/components/form/enums";

export function renderSearchForm(el: Element) {
  const form = new SearchForm(el, items)
  return form
}

const items = [
  createFormItem('任务名称', 'jobName', FORM_ITEM.INPUT),
  createFormItem('任务分组', 'jobGroup', FORM_ITEM.SELECT, { dictCode: 'job_group' }),
  createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'JOB_STATUS' }),
]